export const interestRoutePaths = {
  interest: {
    path: 'interest',
    fullPath: '/interest',
  },
};
